import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';

if (environment.production) {
  enableProdMode();
}

config({ licenseKey });

async function bootstrap() {
  await platformBrowserDynamic().bootstrapModule(AppModule);
}

bootstrap().catch(err => console.log(err));

defineCustomElements(window);
